/**
 * Display helpers for payment methods — aligned with old flow.
 * Uses common utils: formatCardName, hideEmailAdress (email masking).
 */

import { formatCardName, hideEmailAdress } from '../../../../common/config/utils';
import type { PaymentMethod } from '../types';

/**
 * Brand/source type label for display (matches old getSourceType).
 * Used in list card label and details card header.
 */
export function getPaymentMethodBrandLabel(method: PaymentMethod): string {
  switch (method.kind) {
    case 'cc':
      return method.label ? formatCardName(method.label) : 'Card';
    case 'pp':
      return 'PayPal';
    case 'ap':
    case 'am':
      return 'Apple Pay';
    case 'gp':
      return 'Google Pay';
    case 'iap':
      return 'In-app purchase';
    default:
      return method.kind;
  }
}

/**
 * Mask PayPal (or any) email for display — same as old hideEmailAdress.
 * Re-export so the flow has one place to import for email masking.
 */
export { hideEmailAdress as maskEmailForDisplay };
